import React, { useEffect } from 'react';
import { AppLayout } from '@ui/components/organisms';
import { initHttpClient, initOutBoundHttpClient } from '@services/Core';
import { QueryClient, QueryClientProvider } from 'react-query';
import { initializeGTM } from '@utils/gtm';
import { TranslationsProvider } from '@translations/translationsProvider';
import { translations } from '@translations/translations.mappings';
import { AppRoute } from './routes';

const { REACT_APP_API_BASE_URL } = process.env;
const GTM_ID = process.env.REACT_APP_GTM_ID || 'GTM-W572P3V6';

initHttpClient(REACT_APP_API_BASE_URL as string);
initOutBoundHttpClient();

const queryClient = new QueryClient();

export const App: React.FC = () => {
  useEffect(() => {
    initializeGTM(GTM_ID);
  }, []);
  return (
    <QueryClientProvider client={queryClient}>
      <TranslationsProvider messages={translations}>
        <div className="App">
          <AppLayout>
            <AppRoute />
          </AppLayout>
        </div>
      </TranslationsProvider>
    </QueryClientProvider>
  );
};
